// File: client_serena/src/components/MacroBanner.js
import React, { useState } from "react";

function MacroBanner({ healthMetrics, userGoals = [] }) {
const [showInfo, setShowInfo] = useState(false);

const calculateMacros = ({ age, gender, heightCm, weightKg, activityLevel }) => {
if (!age || !gender || !heightCm || !weightKg || !activityLevel) return null;

const bmr = gender === "male"
? 10 * weightKg + 6.25 * heightCm - 5 * age + 5
: 10 * weightKg + 6.25 * heightCm - 5 * age - 161;

const factors = {
sedentary: 1.2,
light: 1.375,
moderate: 1.55,
active: 1.725,
very_active: 1.9,
};

const tdee = bmr * (factors[activityLevel] || 1.2);
const deficit = tdee - 300;
const surplus = tdee + 300;

return {
tdee: Math.round(tdee),
maintenance: Math.round(tdee),
weightLoss: Math.round(deficit),
weightGain: Math.round(surplus),
macros: {
carbs: Math.round((0.5 * tdee) / 4),
protein: Math.round((0.25 * tdee) / 4),
fat: Math.round((0.25 * tdee) / 9),
},
};
};

const result = calculateMacros(healthMetrics || {});
if (!result) return <p>ℹ️ Update your health metrics to view macro targets.</p>;

const goalMsg = userGoals.includes("weight loss")
? `Your plan supports a daily ~300 kcal deficit for healthy weight loss.`
: userGoals.includes("muscle gain")
? `Your plan includes a ~300 kcal surplus to support strength goals.`
: `You’re currently on a balanced maintenance plan.`;

return (
<div style={{ backgroundColor: "#fff3cd", border: "1px solid #ffeeba", padding: "1rem", borderRadius: "6px", marginTop: "1rem" }}>
<div style={{ display: "flex", justifyContent: "space-between" }}>
<h4>
🎯 Daily Macro Breakdown
<button
onClick={() => setShowInfo(true)}
style={{
marginLeft: "0.5rem",
background: "none",
border: "none",
cursor: "pointer",
color: "#007bff",
}}
title="How are these numbers calculated?"
>
ℹ️
</button>
</h4>
</div>
<p><strong>TDEE (Maintenance):</strong> {result.maintenance} kcal/day</p>
<p><strong>Weight Loss Target:</strong> {result.weightLoss} kcal/day</p>
<p><strong>Weight Gain Target:</strong> {result.weightGain} kcal/day</p>
<p><strong>Suggested Macros:</strong></p>
<ul>
<li>🥔 Carbs: {result.macros.carbs}g</li>
<li>🍗 Protein: {result.macros.protein}g</li>
<li>🥑 Fats: {result.macros.fat}g</li>
</ul>

{showInfo && (
<div
style={{
marginTop: "1rem",
backgroundColor: "#fff",
border: "1px solid #ccc",
padding: "1rem",
borderRadius: "5px",
}}
>
<h5>🧠 How This Works</h5>
<p>
We calculate your TDEE using your age, height, weight, gender, and activity level.
Based on your goals, we suggest a calorie deficit (for weight loss) or surplus (for weight gain).
</p>
<p>
Macro split: 50% Carbs, 25% Protein, 25% Fat — based on total calories.
</p>
<button
onClick={() => setShowInfo(false)}
style={{
marginTop: "0.5rem",
padding: "0.3rem 1rem",
backgroundColor: "#dc3545",
color: "white",
border: "none",
borderRadius: "4px",
}}
>
Close
</button>
</div>
)}

<p style={{ fontStyle: "italic", marginTop: "0.5rem" }}>{goalMsg}</p>
{showInfo && (
<div style={{ marginTop: "1rem", fontSize: "0.85rem", color: "#444" }}>
<strong>How this works:</strong><br />
TDEE (Total Daily Energy Expenditure) = BMR × Activity Factor.<br />
Macros are based on 50% carbs, 25% protein, 25% fats split.
</div>
)}
</div>
);
}

export default MacroBanner;